<template>
    <div class="mitbutter-header">
        <header class="header clearfix">
            <top-navigation></top-navigation>
            <a class="d-none d-md-block" href="https://www.kambly.com">
                <img class="header__logo" src="../assets/images/frontend/logo_kambly.webp" alt="">
            </a>
            <a class="d-block d-md-none" href="http://www.kambly.com">
                <img class="header__logo-mobile" src="../assets/images/frontend/logo_kambly_small.webp" alt="">
            </a>
        </header>
    </div>
</template>
<script>
    import TopNavigation from './TopNavigation'

    export default {
        components: {
            TopNavigation
        },
        mounted: function() {
            window.addEventListener('scroll', () => {
                let header = document.querySelector('header');
                let nav = document.querySelector('nav');
                if (window.pageYOffset > 0) {
                    header.classList.add('header--scrolled');
                    nav.classList.add('top-navigation--scrolled');
                } else {
                    header.classList.remove('header--scrolled');
                    nav.classList.remove('top-navigation--scrolled');
                }
            });
        }
    }
</script>

<style lang="scss">
    .mitbutter-header {
        .header {
            position: absolute;
            background-color: transparent;
        }

        .language-switch__context {
            top: 85px;
            left: 40px;
        }
    }
</style>
